/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gt_SkillsInputs */

const en_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills`)
};

const ar_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المهارات`)
};

const bn_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দক্ষতা`)
};

const de_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fähigkeiten`)
};

const es_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidades`)
};

const fr_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compétences`)
};

const pt_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidades`)
};

const zh_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技能`)
};

const tr_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beceriler`)
};

const ru_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Навыки`)
};

const pl_gt_skills = /** @type {(inputs: Gt_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umiejętności`)
};

/**
* | output |
* | --- |
* | "Skills" |
*
* @param {Gt_SkillsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const gt_skills = /** @type {((inputs?: Gt_SkillsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gt_SkillsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_gt_skills(inputs)
	if (locale === "bn") return bn_gt_skills(inputs)
	if (locale === "de") return de_gt_skills(inputs)
	if (locale === "es") return es_gt_skills(inputs)
	if (locale === "fr") return fr_gt_skills(inputs)
	if (locale === "pt") return pt_gt_skills(inputs)
	if (locale === "zh") return zh_gt_skills(inputs)
	if (locale === "tr") return tr_gt_skills(inputs)
	if (locale === "ru") return ru_gt_skills(inputs)
	if (locale === "pl") return pl_gt_skills(inputs)
	return en_gt_skills(inputs)
});